const RECRUIT_SOURCE = {
  GUEST_LINK: 'guest_link',
  CUSTOM_COMMUNITY: 'custom_community',
  HIGHLIGHT_COMMUNITY: 'highlight_community',
} as const;

export type RecruitSource = (typeof RECRUIT_SOURCE)[keyof typeof RECRUIT_SOURCE];

export default RECRUIT_SOURCE;
